<section id="dacHighlight-id" class="dac-highlight">
  <div class="box">
    <div class="box-title mobile"
      ><span>{{ 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.HIGHLIGHT.HEADING' | translate }}</span></div
    >
    <div class="box-image">
      <picture>
        <source
          srcset="
            https://flowaccountcdn.com/new_landing/image/event/digital-accounting-conference/highlight/Banner_Content_1_Edit.webp
          "
          type="image/webp"
        />
        <img
          loading="lazy"
          src="https://flowaccountcdn.com/new_landing/image/event/digital-accounting-conference/highlight/Banner_Content_1_Edit.png"
          class="box-image__layout"
          alt="highlight"
        />
      </picture>
    </div>
    <div class="box-content">
      <div class="box-content__title desktop"
        ><span>{{ 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.HIGHLIGHT.HEADING' | translate }}</span></div
      >
      <div class="box-content__wrapper">
        <div class="box-content__wrapper--element" *ngFor="let item of highlightItems">
          <img [src]="item.icon" [alt]="item.title | translate" loading="lazy" class="element-icon" />
          <div class="element-list">
            <div class="element-list__title"
              ><span>{{ item.title | translate }}</span></div
            >
            <div class="element-list__detail"
              ><span>{{ item.desc | translate }}</span></div
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
